import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-org-trust-marketplace-help-modal',
  templateUrl: './org-trust-marketplace-help-modal.component.pug',
  styleUrls: ['./org-trust-marketplace-help-modal.component.scss'],
  standalone: false
})
export class OrgTrustMarketplaceHelpModalComponent implements OnInit {
  @Input() isUpdate!: boolean;
  constructor(public _bsModalRef: BsModalRef,) { }

  ngOnInit(): void {
  }
  
  closeModal() {
    this._bsModalRef.hide();
  }

}
